/* eslint-disable max-classes-per-file */
import { Uuid } from '@ftr/contracts/type/shared'

export class FetchOrganizationsAction {
  static readonly type = '[Organization] Fetch Organizations'

  constructor(public bypassCache?: boolean) {}
}

/**
 * Marks an organization as the one the user is working within, fetching the user's organizations
 * if we don't have them yet.
 */
export class SelectOrganizationAction {
  static readonly type = '[Organization] Select Organization'

  constructor(public organizationId: Uuid | undefined) {}
}

export class ResetOrganizationStateAction {
  static readonly type = '[Organization] Reset Organization State'
}
